import { render } from "./paymentDialog.vue?vue&type=template&id=e55adbb2"
import script from "./paymentDialog.vue?vue&type=script&lang=js"
export * from "./paymentDialog.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/clients-dev.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__